<template>
  <div id="app">
    <AppNavbar />
    <router-view />
    <AppFooter />
  </div>
</template>


<script>
import AppNavbar from "./components/Navbar.vue";
import AppFooter from "./components/Footer.vue";

import axios from 'axios'
import { API_ENDPOINT } from './config'


axios.post(`${API_ENDPOINT}/`, {
  
  pagina: window.location.pathname
}).catch(() => {})
export default {
  components: {
    AppNavbar,
    AppFooter,
  },
};
</script>


